import { useState } from "react";

const useElapsedTime = (): Date => {
  const [startTime] = useState(() => {
    const time = new Date();
    console.log("⏰ Study session started:", {
      startTime: time.toISOString(),
      timestamp: time.getTime()
    });
    return time;
  }); // Initialize with a Date object

  return startTime; // Always return a valid Date
};

export default useElapsedTime;
